import { REQUEST_SIZE } from 'constants/general';
import { toIsoDateFormat } from 'utils';

export const queryParamsFactory = (formData, sort) => {
	return {
		page: 0,
		size: REQUEST_SIZE,
		sort,
		startDate: toIsoDateFormat(formData.dateFrom),
		endDate: toIsoDateFormat(formData.dateTo),
		parentActivityId: formData.service,
		activityId: formData.serviceType,
		productId: formData.product ? Number(formData.product) : null,
		resultActivityId: formData.result,
		policyNo: formData.policyNumber,
		contactFormIds: formData.contactType,
	};
};
